import { Pipe, PipeTransform } from '@angular/core';

/** Pipe transforms a dictionary object into an array of key value pairs that can iterated */
@Pipe({
  name: 'objToKeyValPairs',
  standalone: false
})
export class ObjToKeyValPairsPipe implements PipeTransform {

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: any, args?: any): any {
    return value ? Object.keys(value).map(key => ({ key, val: value[key] })) : [];
  }

}
